import React, { useState, useEffect } from 'react';
// import { CheckCircle } from "lucide-react";
import 'bootstrap/dist/css/bootstrap.min.css';
import './curose.css';

const Landingpage = () => {

    const [currentBgIndex, setCurrentBgIndex] = useState(0);

    // Images for the background slideshow
    const backgroundImages = [
        'https://res.cloudinary.com/drevfgyks/image/upload/v1728211578/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/top-view-herbal-therapy-products_zwha4f.jpg',
        'https://res.cloudinary.com/drevfgyks/image/upload/v1728212020/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/flat-lay-asian-food-spices-mix-chopsticks_wovqks.jpg',
        'https://res.cloudinary.com/drevfgyks/image/upload/v1722939558/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/beautiful-japanese-forest-scene_rgifox.jpg',
        'https://res.cloudinary.com/drevfgyks/image/upload/v1728212675/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/Wood_plants_rh6lnf.jpg',
        'https://res.cloudinary.com/drevfgyks/image/upload/v1728213001/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/close-up-adult-cooking_l1rsne.jpg',
        'https://res.cloudinary.com/drevfgyks/image/upload/v1728213007/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/modern-kitchen-composition-with-healthy-ingredients_rnxjc5.jpg'
    ];

    // Data for the static content
    // const features = [
    //     {
    //         title: "100% Pure & Authentic",
    //         description: "Ethically sourced from sustainable Agarwood plantations.",
    //     },
    //     {
    //         title: "Exquisite Fragrance",
    //         description: "A natural blend of sweet, woody, and musky notes.",
    //     },
    //     {
    //         title: "Premium Quality",
    //         description: "Carefully harvested and processed to retain its natural essence.",
    //     },
    //     {
    //         title: "Luxury Packaging",
    //         description: "Designed for personal use, gifting, or exclusive collections.",
    //     },
    // ];

    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentBgIndex((prevIndex) => (prevIndex + 1) % backgroundImages.length);
        }, 5000); // Change image every 5 seconds

        return () => clearInterval(interval);
    }, [backgroundImages.length]);

    return (
        <section className="hero-section">
            {/* Background Slideshow */}
            <div className="hero-backgrounds">
                {backgroundImages.map((img, index) => (
                    <div
                        key={index}
                        className={`hero-bg-image ${index === currentBgIndex ? 'active' : ''}`}
                        style={{ backgroundImage: `url(${img})` }}
                    ></div>
                ))}
                <div className="hero-overlay"></div>
            </div>

            {/* Static Content Overlay */}
            <div className="container h-100 hero-content-wrapper">
                <div className="row h-100 align-items-center">

                    {/* Text Content */}
                    <div className="col-lg-6 col-md-12 mb-5 mb-lg-0">
                        <div className="glass-card fade-in-up">
                            <h2 className="CarouselComponent-hero-title">🌿Why choose ANT Multi Cropping Project (MCP) – As for Farmer, As per Corporate, As per Natural Way</h2>
                            {/* <ul className="feature-list">
                                {features.map((feature, index) => (
                                    <li key={index} className="feature-item">
                                        <CheckCircle className="icon" />
                                        <div>
                                            <h5 className="feature-title">{feature.title}</h5>
                                            <p className="feature-desc">{feature.description}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul> */}
                        </div>
                    </div>

                    {/* Founder Images */}
                    <div className="col-lg-6 col-md-12">
                        <div className="hero-image-composition">
                            <img
                                src='https://res.cloudinary.com/drevfgyks/image/upload/v1738329060/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/Ant-founder-image-2_zfa21w.jpg'
                                className='hero-img img-primary'
                                alt='Founder 1'
                            />
                            <img
                                src='https://res.cloudinary.com/drevfgyks/image/upload/v1738329060/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/Ant-founder-image_j00gc8.jpg'
                                className='hero-img img-secondary'
                                alt='Founder 2'
                            />
                            <img
                                src='https://res.cloudinary.com/drevfgyks/image/upload/v1729492071/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/WhatsApp_Image_2024-10-21_at_11.37.24_11477968_c9vljv.jpg'
                                className='hero-img img-third'
                                alt='Founder 3'
                            />
                            {/* <img
                                src='https://res.cloudinary.com/drevfgyks/image/upload/v1729944086/AMARAVATHI%20NATURO%20TECH%20PVT%20LTD/WhatsApp_Image_2024-10-23_at_13.42.00_9c0033fb_spavnf.jpg'
                                className='hero-img img-fourth'
                                alt='Founder 4'
                            /> */}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Landingpage;
